import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Bottom tab bar fija para la experiencia mobile alternativa (rutas /m/*).
 * Cuatro destinos principales: Home, Álbum, Mensajes, Perfil. Tap target
 * 56px mínimo, soporta safe-area-bottom de iOS.
 */
const TABS = [
  { path: '/m',          icon: 'home',       label: 'Inicio' },
  { path: '/m/album',    icon: 'photo_library', label: 'Álbum' },
  { path: '/m/messages', icon: 'forum',      label: 'Mensajes' },
  { path: '/m/profile',  icon: 'person',     label: 'Perfil' },
];

export default function MobileTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Navegación principal"
      className="fixed inset-x-0 bottom-0 z-50 bg-surface border-t border-outline-variant flex items-stretch"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
    >
      {TABS.map(({ path, icon, label }) => {
        const active = pathname === path || (path !== '/m' && pathname.startsWith(path));
        return (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            className={`flex-1 min-h-[56px] flex flex-col items-center justify-center gap-0.5 transition-colors bg-transparent border-0 cursor-pointer appearance-none focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
              active ? 'text-primary' : 'text-on-surface-variant hover:text-on-surface'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            <span
              className="material-symbols-outlined text-[24px]"
              style={active ? { fontVariationSettings: "'FILL' 1" } : undefined}
            >
              {icon}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-wide">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
